var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPinCircleOutsideStroke({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 14C55.9117 14 68 26.2724 68 41C68 52.0493 61.1958 61.5292 51.5 65.5752C46.4879 67.6667 44.75 68.4444 43.25 71.4072C43.1039 71.6957 42.9791 71.9706 42.8633 72.2256C42.3843 73.2796 42.0568 74 41 74C39.9432 74 39.6157 73.2796 39.1367 72.2256C39.0209 71.9706 38.8961 71.6957 38.75 71.4072C37.25 68.4444 35.3749 67.6667 30.5 65.5752C20.8042 61.5292 14 52.0493 14 41C14 26.2724 26.0883 14 41 14ZM41 17C27.7452 17 17 27.7452 17 41C17 54.2548 27.7452 65 41 65C54.2548 65 65 54.2548 65 41C65 27.7452 54.2548 17 41 17Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPinCircleOutsideStroke);
export default __webpack_public_path__ + "static/media/ic_pin_circle_outside_stroke.728fdfa391340042759dc9b66544f6e5.svg";
export { ForwardRef as ReactComponent };